function createFavoritesCardList(dataArray, parentContainer){
    const arr = dataArray;

    arr.map(card => parentContainer.append(createFavoritesLogoCardMarkup(card)));
}

function createFavoritesLogoCardMarkup(card){
    const baseElement = 'a';
    const isLink = baseElement === 'a' ? true : false;
    const baseLink = isLink ? `href='${card.linkUrl}'` : '';
 
    const cardMarkup = 
    `<${baseElement} class="card card--small js-card" ${baseLink} data-id='${card.id}'> 
        <div class='card__img-wrap'>
            ${card.imageUrl !== false
                ?  `<img class='card__img' src="${card.imageUrl}" alt="logo" loading='lazy'>`
                : `<div class="c-gray-7">
                    <svg class="icon h-80">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/images/svg-sprite.svg#logo"></use>
                    </svg>
                </div>`
            }
            ${card.favorite ? '<span class="card__favorite js-card-icon-favorite"></span>' : ''}
        </div>
        <div class='card__info'>
            <div class='card__title'>${card.title}</div>
            ${card.date !== false
                ? `<div class="card__bottom"><div class="card__bottom-text c-dark">${card.date}</div></div>`
                : ''}
        </div>
    </${baseElement}>`

    return cardMarkup;
}

$(document).ready(function(){
    if ($('.js-favorites-container-events').length && favoritesEventsData.length > 0){
        createFavoritesCardList(favoritesEventsData, $('.js-favorites-container-events'));
    }

    if ($('.js-favorites-container-mountains').length && favoritesMountainsData.length > 0){
        createFavoritesCardList(favoritesMountainsData, $('.js-favorites-container-mountains'));
    }

    if ($('.js-favorites-container-teams').length && favoritesTeamsData.length > 0){
        createFavoritesCardList(favoritesTeamsData, $('.js-favorites-container-teams'));
    }
});



